import { render, staticRenderFns } from "./ResolveDoboxaErrorDialog.vue?vue&type=template&id=748d1f3a&scoped=true"
import script from "./ResolveDoboxaErrorDialog.vue?vue&type=script&lang=js"
export * from "./ResolveDoboxaErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748d1f3a",
  null
  
)

export default component.exports